import styled from 'styled-components';

export const Container = styled.div`
  .ant-row {
    margin: 10px 0;
  }

  .ant-tabs-tab-btn {
    margin-left: 15px;
  }

  .button-edit {
    margin-right: 6px;
  }
`;
